import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

const PasswordRequirements = (props) => {
  const { t } = useTranslation();
  const { formSubmitted, password, errorText, showPasswordDiffItem } = props;
  const hasSpecialCharacter = (value) => {
    const specialCharacterRegEx = new RegExp(
      "[!\"#$%&'()*+,-./:;<=>?@[\\]^_`{|}~]"
    );
    return specialCharacterRegEx.test(value);
  };
  const isPassedPasswordRequirements = (key) => {
    let classNameText = "";
    switch (key) {
      case "nineCharacters":
        if (formSubmitted && password.length < 9) {
          classNameText = "failed";
        } else if (password.length >= 9) {
          classNameText = "passed";
        }
        break;
      case "capitalLetter":
        if (formSubmitted && !password.match("[A-Z]")) {
          classNameText = "failed";
        } else if (password.match("[A-Z]")) {
          classNameText = "passed";
        }
        break;
      case "oneNumber":
        if (formSubmitted && !password.match("[0-9]")) {
          classNameText = "failed";
        } else if (password.match("[0-9]")) {
          classNameText = "passed";
        }
        break;
      case "smallLetter":
        if (formSubmitted && !password.match("[a-z]")) {
          classNameText = "failed";
        } else if (password.match("[a-z]")) {
          classNameText = "passed";
        }
        break;
      case "charactersAllowed":
        if (formSubmitted && (password.length > 64 || password.length === 0)) {
          classNameText = "failed";
        } else if (password.length <= 64 && password.length !== 0) {
          classNameText = "passed";
        }
        break;
      case "specialCharacter":
        if (formSubmitted && !hasSpecialCharacter(password)) {
          classNameText = "failed";
        } else if (hasSpecialCharacter(password)) {
          classNameText = "passed";
        }
        break;
      case "compareWithOldPassword":
        if (
          password.length > 0 &&
          errorText !== "pages.passwordReset.mustBeNewPassword"
        ) {
          classNameText = "passed";
        }
        break;
      default:
        classNameText = "";
        break;
    }
    return classNameText;
  };
  return (
    <ul className="password-terms list-unstyled" id="password-requirements">
      <li className={isPassedPasswordRequirements("nineCharacters")}>
        {t("pages.registration.nineCharacters")}
      </li>
      <li className={isPassedPasswordRequirements("capitalLetter")}>
        {t("pages.registration.capitalLetter")}
      </li>
      {showPasswordDiffItem && (
        <li className={isPassedPasswordRequirements("compareWithOldPassword")}>
          {t("pages.registration.differentFromCurrentPassword")}
        </li>
      )}
      <li className={isPassedPasswordRequirements("oneNumber")}>
        {t("pages.registration.oneNumber")}
      </li>
      <li className={isPassedPasswordRequirements("smallLetter")}>
        {t("pages.registration.oneLowerLetter")}
      </li>
      <li className={isPassedPasswordRequirements("specialCharacter")}>
        {t("pages.registration.specialCharacter")}
      </li>      
      <li className={isPassedPasswordRequirements("charactersAllowed")}>
        {t("pages.registration.charactersAllowed")}
      </li>
    </ul>
  );
};

PasswordRequirements.propTypes = {
  password: PropTypes.string.isRequired,
  formSubmitted: PropTypes.bool.isRequired,
  showPasswordDiffItem: PropTypes.bool,
  errorText: PropTypes.string
};
PasswordRequirements.defaultProps = {
  showPasswordDiffItem: false,
  errorText: ""
};

export default PasswordRequirements;
